import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import {
    ProcessAttachmentsAggregate,
    PurchasingAttachment,
} from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    InitiateAttachmentPayload,
    UpdateAttachmentPayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface GetProcessAttachments {
    execute(processId: string): Promise<ProcessAttachmentsAggregate>
}

export class GetProcessAttachmentsUseCase implements GetProcessAttachments {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string) {
        return this.repository.getProcessAttachments(processId)
    }
}

export interface InitiateAttachment {
    execute(
        processId: string,
        payload: InitiateAttachmentPayload
    ): Promise<PurchasingAttachment>
}

export class InitiateAttachmentUseCase implements InitiateAttachment {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        payload: InitiateAttachmentPayload
    ): Promise<PurchasingAttachment> {
        return this.repository.initiateAttachment(processId, payload)
    }
}

export interface CompleteAttachment {
    execute(
        processId: string,
        attachmentId: string
    ): Promise<PurchasingAttachment>
}

export class CompleteAttachmentUseCase implements CompleteAttachment {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        attachmentId: string
    ): Promise<PurchasingAttachment> {
        return this.repository.completeAttachment(processId, attachmentId)
    }
}

export interface UpdateAttachmentOp {
    execute(
        processId: string,
        attachmentId: string,
        payload: UpdateAttachmentPayload
    ): Promise<PurchasingAttachment>
}

export class UpdateAttachmentUseCase implements UpdateAttachmentOp {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        attachmentId: string,
        payload: UpdateAttachmentPayload
    ): Promise<PurchasingAttachment> {
        return this.repository.updateAttachment(processId, attachmentId, payload)
    }
}

export interface DeleteAttachment {
    execute(
        processId: string,
        attachmentId: string
    ): Promise<{ removed: boolean; storageRemoved: boolean }>
}

export class DeleteAttachmentUseCase implements DeleteAttachment {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        attachmentId: string
    ): Promise<{ removed: boolean; storageRemoved: boolean }> {
        return this.repository.deleteAttachment(processId, attachmentId)
    }
}
